module.exports = __webpack_public_path__ + "427bd9b7e3affbf16e332838ea1b1817.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_1_b.png
// module id = 156
// module chunks = 0